import { doc, updateDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase/firebase";

/**
 * updateQuestion
 * Updates a question document in Firestore.
 * This ONLY touches the question itself — never packets or diagnostics.
 *
 * @param {Object} question - Full question object from the editor
 * @throws if question.id is missing
 */
export async function updateQuestion(question) {
  if (!question?.id) {
    throw new Error("updateQuestion: question.id is required");
  }

  const ref = doc(db, "questions", question.id);

  const correct =
    typeof question.answer?.correct === "string"
      ? question.answer.correct.trim()
      : typeof question.correctAnswer === "string"
      ? question.correctAnswer.trim()
      : "";

  // ---- normalize payload ----
  const payload = {
    // core content
    passage: question.passage ?? question.context ?? "",
    question: question.question ?? question.prompt ?? "",
    difficulty: question.difficulty ?? 1,
    estimatedTimeSeconds: question.estimatedTimeSeconds ?? 45,

    // answer config
    answer: {
      type: question.answer?.type ?? "mc", // "mc" | "fitb"
      correct,
    },

    // only include choices if MC
    answerChoices:
      question.answer?.type === "fitb"
        ? null
        : question.answerChoices ?? {},

    calculatorAllowed: !!question.calculatorAllowed,

    // taxonomy
    primaryCategory: question.primaryCategory ?? "",
    secondaryCategories: question.secondaryCategories ?? [],
    domain: question.domain ?? "",
    section: question.section ?? "",

    // audit
    updatedAt: serverTimestamp(),
  };

  // remove undefined keys (Firestore-safe)
  Object.keys(payload).forEach((k) => {
    if (payload[k] === undefined) delete payload[k];
  });

  await updateDoc(ref, payload);
}
